import React, { Component } from 'react'
import { reaction } from 'mobx'
import { inject, observer } from 'mobx-react'

import VoucherItem from './VoucherItem'

import api from '../services'
import config from '../config'
const { pvIds } = config

@inject('dialogInfo')
@inject('cityInfo')
@observer
export default class VoucherFloor extends Component {
  constructor(props){
    super(props)
    this.state = {
      list: []
    }
    reaction(
      () => this.props.cityInfo.info.cityId,
      cityId => this.loadData()
    )
    this.loadData = this.loadData.bind(this)
  }

  async loadData(){
    let { cityId } = this.props.cityInfo.info
    /**
     * @description: 提车城市为当前定位城市、带红包的上架的商品
     */
    let goodsRes = await api.searchItem({
      pickCityId: cityId,
      businessFlag: 1,
      dataSources: '',
      pageSize: 20
    })

    if(goodsRes.returncode === 0 && goodsRes.result && goodsRes.result.list){
      /**
       * @description: 批量查询商品下红包数据
       */
      let goodsList = goodsRes.result.list,
      itemIds = goodsList.map(ele=>ele.itemId).join(',')

      if(goodsList.length === 0) {
        this.setState({list: []})
        return
      }

      let couponRes = await api.getListByIds(itemIds)
      if(couponRes.success) {
        let couponList = couponRes.result
        goodsList.map(goods => {
          couponList.map(coupon => {
            if(+coupon.id === goods.itemId) goods.couponL = coupon.list
          })
        })
        this.setState({
          list: goodsList
        })
      }else {
        this.setState({list: []})
      }
    }
  }

  componentDidMount(){
    this.loadData()
  }

  render(){
    let { list } = this.state

    return(
      <div className={list.length?'':'fn-hide'}>
        <div className='title' style={{paddingTop: 0}}>
          <span>购车先领券</span>
        </div>
        {
          list.map((ele,index)=>
            <VoucherItem
              key={index}
              pvId={[pvIds.voucherGoods,pvIds.voucherUse]}
              show={this.props.dialogInfo.show}
              cityInfo={this.props.cityInfo.info}
              coupon={ele}
            />
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/VoucherFloor.js